export default __webpack_public_path__ + "static/media/Conozca su cuenta de correo institucional y su estado el SIE.a258b44b.png";